import { ButtonProps, chakra, IconProps } from '@chakra-ui/react';
import { CheckIcon, CopyClipboardIcon } from '@sphere/icons';
import { rem } from 'polished';
import { PropsWithChildren, useState } from 'react';
import { toast } from 'sonner';

interface Props extends ButtonProps {
  content: string;
  tooltipContent: {
    success: string;
    failed: string;
  };
  iconProps?: IconProps;
}

export const CopyButton = ({
  content,
  tooltipContent,
  children,
  iconProps,
  ...props
}: PropsWithChildren<Props>) => {
  const [hasCopied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(content)
      .then(() => {
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 5000);
        toast.success(tooltipContent.success, { id: `${content}-success` });
      })
      .catch(() => toast.error(tooltipContent.failed, { id: `${content}-failed` }));
  };

  return (
    <chakra.button
      display="flex"
      alignItems="center"
      gap="space.4"
      onClick={copyToClipboard}
      transition="opacity 120ms ease-in-out"
      _hover={{ opacity: 0.6 }}
      _focus={{ outline: 'none' }}
      _focusVisible={{ boxShadow: 'outline' }}
      {...props}
    >
      {children}
      {hasCopied ? (
        <CheckIcon boxSize={rem(16)} {...iconProps} />
      ) : (
        <CopyClipboardIcon boxSize={rem(16)} {...iconProps} />
      )}
    </chakra.button>
  );
};
